module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-happy.44798698.png";